import React from 'react';
type SectionProps = {
  id: string;
  index: string;
  label: string;
  children: React.ReactNode;
  className?: string;
  fill?: boolean;
};
export function Section({
  id,
  index,
  label,
  children,
  className = '',
  fill = false
}: SectionProps) {
  return <section id={id} aria-labelledby={`${id}-label`} className={`slide relative flex w-full snap-start snap-always flex-col justify-center overflow-hidden border-t border-white/10 px-6 py-10 sm:px-10 lg:px-14 ${className}`} data-id="element-33" data-mp="3fyhv3ryap76w">
      <div className={`mx-auto w-full max-w-[1240px] ${fill ? 'flex min-h-0 flex-1 flex-col' : ''}`} data-id="element-34" data-mp="hf16c5fy7zhy">
        <p id={`${id}-label`} className="mb-6 flex items-center gap-3 font-body text-xs uppercase tracking-[0.28em] text-secondary/70" data-id="element-35" data-mp="2pc03vt015at">
          <span className="text-primary" data-id="element-36" data-mp="ve96b0jxrbn7">{index}</span>
          <span className="h-px w-8 bg-secondary/30" aria-hidden="true" data-id="element-37" data-mp="vcpsdglr5col" />
          {label}
        </p>
        {children}
      </div>
    </section>;
}
export function SectionTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h2 className={`font-heading text-3xl leading-[1.08] text-white sm:text-4xl lg:text-[2.9rem] ${className}`} data-id="element-38" data-mp="2unbrxak96qxq">
      {children}
    </h2>;
}
export function Lead({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <p className={`font-body text-base leading-relaxed text-white/70 lg:text-lg ${className}`} data-id="element-39" data-mp="3i9s4cpfgygd6">
      {children}
    </p>;
}
export function Statement({
  children
}: {
  children: React.ReactNode;
}) {
  return <blockquote className="border-l-2 border-primary pl-5" data-id="element-40" data-mp="3rayln0pxzv7h">
      <p className="font-heading text-2xl leading-snug text-primary lg:text-3xl" data-id="element-41" data-mp="3n9wii8swmz08">{children}</p>
    </blockquote>;
}